/**
 * @param {string} targetVersion
 * @param {string} myVersion
 * compareAPPVersion 에서 사용
 */
const compare = (targetVersion, myVersion) => {
  if (myVersion === targetVersion) {
    return 0;
  }
  const [myVersionMajor = '0', myVersionMinor = '0', myVersionPatch = '0'] = myVersion.split('.');
  const [targetVersionMajor = '0', targetVersionMinor = '0', targetVersionPatch = '0'] = targetVersion.split('.');
  const myVersionMajorNumber = parseInt(myVersionMajor);
  const myVersionMinorNumber = parseInt(myVersionMinor);
  const myVersionPatchNumber = parseInt(myVersionPatch);
  const targetVersionMajorNumber = parseInt(targetVersionMajor);
  const targetVersionMinorNumber = parseInt(targetVersionMinor);
  const targetVersionPatchNumber = parseInt(targetVersionPatch);
  if (targetVersionMajorNumber > myVersionMajorNumber) {
    return 1;
  }
  if (targetVersionMajorNumber < myVersionMajorNumber) {
    return -1;
  }
  if (targetVersionMinorNumber > myVersionMinorNumber) {
    return 1;
  }
  if (targetVersionMinorNumber < myVersionMinorNumber) {
    return -1;
  }
  if (targetVersionPatchNumber > myVersionPatchNumber) {
    return 1;
  }
  if (targetVersionPatchNumber < myVersionPatchNumber) {
    return -1;
  }
  return 0;
};
function compareAPPVersion(targetAppVersion, operator, currentAppVersion) {
  const result = compare(targetAppVersion, currentAppVersion);
  const operatorMap = {
    gt: 'gt',
    gte: 'gte',
    lt: 'lt',
    lte: 'lte',
    eq: 'eq',
    '>': 'gt',
    '<': 'lt',
    '>=': 'gte',
    '<=': 'lte',
    '=': 'eq'
  };
  switch (operatorMap[operator]) {
    case 'gt':
      {
        return result === 1;
      }
    case 'gte':
      {
        return result === 1 || result === 0;
      }
    case 'lt':
      {
        return result === -1;
      }
    case 'lte':
      {
        return result === -1 || result === 0;
      }
    case 'eq':
      {
        return result === 0;
      }
    default:
      {
        throw new TypeError(`Unexpected Operator, ${operator}`);
      }
  }
}

export { compareAPPVersion };
